import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_3938)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M15 5H2.5C2.15482 5 1.875 5.27982 1.875 5.625V14.375C1.875 14.7202 2.15482 15 2.5 15H15C15.3452 15 15.625 14.7202 15.625 14.375V5.625C15.625 5.27982 15.3452 5 15 5Z",
			stroke: "#4D4D4D",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M15.625 8.75L19.0625 6.25V13.75L15.625 11.25",
			stroke: "#4D4D4D",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_3938",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgVideo;
